import { Alert, Button } from '@heroui/react';
import classNames from 'classnames';
import type { CSSProperties, ForwardedRef, ReactNode } from 'react';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

/* eslint-disable react/require-default-props */
type Props = {
  readonly className?: string;
  readonly message: ReactNode;
  readonly onClose: () => void;
  readonly style?: CSSProperties;
};
/* eslint-enable react/require-default-props */

const AppNotification = forwardRef(
  ({ className, message, style, onClose }: Props, ref: ForwardedRef<HTMLDivElement>) => {
    const { t } = useTranslation();

    return (
      <Alert
        ref={ref}
        status="accent"
        className={classNames(
          'items-center shadow-overlay animate-in fade-in slide-in-from-top-2 duration-(--duration-medium) ease-(--ease-smooth-out) motion-reduce:slide-in-from-top-0',
          className
        )}
        style={style}
      >
        <Alert.Indicator />
        <Alert.Content>
          <Alert.Description className="[overflow-wrap:anywhere]">{message}</Alert.Description>
        </Alert.Content>
        <Button size="sm" variant="ghost" onPress={onClose}>
          {t('action.got_it')}
        </Button>
      </Alert>
    );
  }
);

export default AppNotification;
